import React from 'react';

import { Chip, Tooltip } from '@mui/material';

import { Rate } from '~/services/AccommodationService';

interface RateTypeBadgeProps {
  rate: Rate;
}

export default function RateTypeBadge({ rate }: RateTypeBadgeProps) {
  if (!rate.meta) {
    return null;
  }

  const isLPP = rate.meta.type === 'bedbank';

  return (
    <Tooltip title={isLPP ? 'Luxury Property Partner' : 'Luxury Property Collection'}>
      <Chip label={isLPP ? 'Bedbank' : 'LPC'} color={isLPP ? 'secondary' : 'primary'} size="small" sx={{ mr: 1 }} />
    </Tooltip>
  );
}
